import { Box, Button } from '@mui/material';
import { Check } from '@mui/icons-material';

interface ReusableFilterButtonProps {
    label: string;
    onToggle: () => void;
    isActive: boolean;
}

const ChipFilterButton = ({
    label,
    onToggle,
    isActive,
}: ReusableFilterButtonProps) => {

    // Custom button that mimics a chip but with more style control
    return (
        <Button
            variant={isActive ? "contained" : "outlined"}
            color={isActive ? "success" : "primary"}
            onClick={onToggle}
            startIcon={<Check />}
            size="small"
            disableRipple
            disableElevation
            sx={{
                border: isActive ? 'none' : '1px solid',
                borderColor: '#00000040',
                padding: '4px 12px',
                textTransform: 'none',
                color: isActive ? '#ffffff' : 'grey',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: isActive ? 'success.main' : 'transparent',
                    boxShadow: 'none',
                    borderColor: '#00000040',
                }
            }}
        >
            {label}
        </Button>
    );
};

export default ChipFilterButton; 